module.exports = __webpack_public_path__ + "img/kaa-gent.930c9ba1.png";